import * as React from "react";
import InteractiveContext from "views/components/contexts/InteractiveContext";
import EvidenceCardFoundation from "./EvidenceCardFoundation";
const EvidenceLogCard = ({ evidence }) => /* @__PURE__ */ React.createElement(InteractiveContext.Provider, { value: false }, /* @__PURE__ */ React.createElement(
  EvidenceCardFoundation,
  {
    title: /* @__PURE__ */ React.createElement("span", null, evidence.entity.id),
    actions: void 0,
    onShowSimilar: void 0,
    hasSimilarFieldsFilter: false,
    evidence,
    isHighlighted: false,
    onResetShowSimilar: () => {
    }
  }
));
export default EvidenceLogCard;
